module.exports = __webpack_public_path__ + "static/HTH3-1784420b4c9a9436fdd0552957ef8328.jpg";